// 포트폴리오 데이터 타입 정의
import { portfolioApi } from '../services/api';

export interface PortfolioVideoItem {
  id: number;
  title: string;
  description: string;
  videoSrc: string;
}

export interface PortfolioContentItem {
  id?: number;
  subTab: string;
  title?: string;
  description?: string;
  src?: string;
  videoSrc?: string; // videoSrc 필드 추가
}

export interface PortfolioTab {
  label: string;
  contentId: string;
  videos?: any[]; // 기존 videos 배열은 유지하되 any 타입으로 변경
  contents?: PortfolioContentItem[];
}



// 디지털 콘텐츠 서브탭 정의
export const digitalCampaignSubTabs = [
  { label: "유튜브 영상", contentId: "youtubeMedia" },
  { label: "온라인 콘텐츠", contentId: "onlineContents" },
  { label: "SNS 운영", contentId: "SNS" },
];

// 포트폴리오 데이터 관리 함수들 (서버 API 사용)
export const getPortfolioData = async (): Promise<PortfolioTab[]> => {
  try {
    return await portfolioApi.getPortfolioData();
  } catch (error) {
    console.error('포트폴리오 데이터 조회 오류:', error);
    throw error;
  }
};

export const savePortfolioData = async (data: PortfolioTab[]): Promise<void> => {
  try {
    await portfolioApi.savePortfolioData(data);
  } catch (error) {
    console.error('포트폴리오 데이터 저장 오류:', error);
    throw error;
  }
};

export const resetPortfolioData = async (): Promise<void> => {
  try {
    await portfolioApi.resetPortfolioData();
  } catch (error) {
    console.error('포트폴리오 데이터 초기화 오류:', error);
    throw error;
  }
}; 